export const iconFontAwesomeHumanitarianHeadset = (
	<i className="fa-solid fa-headset"></i>
);
